import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private api: ApiService) { }

  getAllCompany(data:any): Observable<any> {
    return this.api.post(environment.getAllCompany,data);
  }

  deleteCompany(data:any): Observable<any> {
    return this.api.post(environment.deleteCompany,data);
  }

  createComapny(data:any): Observable<any> {
    return this.api.post(environment.createCompany,data);
  }
  
  updateCompany(data:any): Observable<any> {
    return this.api.post(environment.updateCompany,data);
  }

  createBulkAccount(data:any): Observable<any> {
    return this.api.post(environment.createBulkAccount,data);
  }

  getAllAccount(data:any): Observable<any> {
    return this.api.post(environment.getAllAccount,data);
  }
}


